export function SeasonalTreeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.3817 38.2475C29.0804 38.2475 28.7791 38.2293 28.4778 38.2019L14.2799 36.6406C11.8056 36.3667 9.62341 34.9971 8.29037 32.9701C6.0808 31.5093 4.72037 29.044 4.72037 26.3232V11.8697C4.72037 7.47796 8.29037 3.90796 12.673 3.90796H27.1356C30.4865 3.90796 33.3625 5.9897 34.5312 8.9297C37.5534 10.4271 39.4434 13.6775 39.0599 17.1836L37.5534 30.9249C37.0969 35.1067 33.5817 38.2567 29.3817 38.2567V38.2475Z"
        fill="url(#paint0_linear_21268_24274)"
      />
      <path
        d="M27.1264 7.7334H12.6729C10.3903 7.7334 8.54596 9.57775 8.54596 11.8604V26.3138C8.54596 28.5964 10.3903 30.4408 12.6729 30.4408H27.1264C29.3999 30.4408 31.2533 28.5964 31.2533 26.3138V11.8604C31.2533 9.57775 29.409 7.7334 27.1264 7.7334Z"
        fill="url(#paint1_linear_21268_24274)"
      />
      <path
        d="M31.3683 11.9175L17.1649 10.3544C14.754 10.0891 12.5845 11.8285 12.3191 14.2394L10.807 27.9799C10.5417 30.3909 12.2811 32.5604 14.692 32.8257L28.8954 34.3888C31.3063 34.6541 33.4759 32.9147 33.7412 30.5038L35.2533 16.7633C35.5186 14.3523 33.7792 12.1828 31.3683 11.9175Z"
        fill="url(#paint2_linear_21268_24274)"
      />
      <path
        opacity="0.62"
        d="M28.5142 19.5027C27.6833 19.4114 27.0716 18.6719 27.1355 17.841C26.3411 17.7406 25.7659 17.0192 25.8481 16.2158C25.9303 15.4123 26.6516 14.8279 27.4551 14.901C27.5738 14.0884 28.3224 13.504 29.1624 13.5953C30.0024 13.6866 30.5959 14.4171 30.532 15.2388C31.3355 15.3392 31.9107 16.0697 31.8285 16.8732C31.7464 17.6766 31.0159 18.2519 30.2124 18.1788C30.0938 19.0006 29.3451 19.5849 28.5142 19.4936V19.5027Z"
        fill="url(#paint3_linear_21268_24274)"
      />
      <path
        d="M28.0486 17.8957L28.1399 17.0375L27.2634 16.937C26.9529 16.9005 26.7247 16.6266 26.7612 16.3161C26.7977 16.0057 27.0807 15.7775 27.3912 15.814L28.2677 15.9144L28.359 15.0561C28.3955 14.7092 28.706 14.4627 29.062 14.4992C29.4181 14.5357 29.6555 14.8461 29.619 15.1931L29.5277 16.0514L30.4134 16.1518C30.7238 16.1883 30.9521 16.4714 30.9155 16.7818C30.879 17.0922 30.596 17.3114 30.2855 17.2748L29.3999 17.1744L29.3086 18.0327C29.272 18.3705 28.9616 18.6261 28.6147 18.5896C28.2677 18.5531 28.012 18.2335 28.0486 17.8957Z"
        fill="white"
      />
      <path
        opacity="0.62"
        d="M19.9866 30.8609C19.1831 30.7696 18.6079 30.0483 18.6901 29.2448L18.827 28.0122L17.4027 27.857C16.6722 27.7748 16.0422 27.3 15.7683 26.6153C15.4944 25.9305 15.6222 25.1544 16.0879 24.5883L17.9961 22.3057C17.8866 22.1779 17.7953 22.0227 17.7314 21.8583C17.5122 21.3013 17.6218 20.6805 18.0053 20.224L21.7031 15.7957C22.0409 15.3757 22.5796 15.1657 23.1183 15.2205C23.657 15.2753 24.1318 15.604 24.3783 16.0879L27.0353 21.2192C27.3092 21.7487 27.2727 22.3787 26.9348 22.8718C26.8344 23.0179 26.7157 23.1366 26.5879 23.237L27.9483 25.8757C28.2861 26.5331 28.2405 27.3092 27.8205 27.9209C27.4005 28.5326 26.6883 28.8522 25.9579 28.7792L24.5335 28.624L24.3966 29.8566C24.3053 30.66 23.584 31.2353 22.7805 31.1531L19.9774 30.8427L19.9866 30.8609Z"
        fill="url(#paint4_linear_21268_24274)"
      />
      <path
        d="M27.1446 26.323L25.2455 22.6435L25.5377 22.6708C26.0946 22.7348 26.4964 22.1504 26.2316 21.6482L23.5746 16.5078C23.3464 16.0604 22.7346 15.9965 22.4151 16.38L18.7081 20.8174C18.3429 21.2465 18.6077 21.9039 19.1646 21.9678L19.4477 21.9952L16.7998 25.1726C16.2429 25.8391 16.6538 26.8435 17.512 26.9439L19.8403 27.1995L19.6029 29.3452C19.5664 29.6465 19.7855 29.9204 20.0868 29.9478L22.8898 30.2582C23.1911 30.2948 23.4651 30.0756 23.4925 29.7743L23.7298 27.6287L26.0581 27.8843C26.9164 27.9756 27.5372 27.0808 27.1355 26.3139L27.1446 26.323Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21268_24274"
          x1="16.0878"
          y1="39.8819"
          x2="25.6473"
          y2="4.20926"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FF00" />
          <stop offset="0.52" stopColor="#00FF00" stopOpacity="0.89" />
          <stop offset="1" stopColor="#99FF00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_21268_24274"
          x1="13.166"
          y1="41.1508"
          x2="25.7112"
          y2="0.0638345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005933" />
          <stop offset="0.2" stopColor="#005C31" />
          <stop offset="0.37" stopColor="#00662E" />
          <stop offset="0.52" stopColor="#007727" />
          <stop offset="0.67" stopColor="#008F1F" />
          <stop offset="0.81" stopColor="#00AE14" />
          <stop offset="0.95" stopColor="#00D406" />
          <stop offset="1" stopColor="#00E600" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_21268_24274"
          x1="33.0737"
          y1="10.7454"
          x2="13.845"
          y2="32.9872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00DE00" />
          <stop offset="1" stopColor="#00B800" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_21268_24274"
          x1="30.8303"
          y1="14.955"
          x2="26.8408"
          y2="18.1534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1FD00" stopOpacity="0.8" />
          <stop offset="1" stopColor="#DEFD92" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_21268_24274"
          x1="27.3943"
          y1="19.8033"
          x2="16.927"
          y2="28.1952"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1FD00" stopOpacity="0.8" />
          <stop offset="1" stopColor="#DEFD92" stopOpacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
